/**
 * CMS SDK - 类型定义
 * 内容管理系统的核心类型
 */

// 内容类型枚举
export const ContentType = {
  ARTICLE: 'article',      // 文章
  POST: 'post',            // 帖子/动态
  IMAGE: 'image',          // 图片
  VIDEO: 'video',          // 视频
  AUDIO: 'audio',          // 音频
  DOCUMENT: 'document',    // 文档
};

// 内容状态枚举
export const ContentStatus = {
  DRAFT: 'draft',          // 草稿
  PENDING: 'pending',      // 待审核
  APPROVED: 'approved',    // 已发布
  REJECTED: 'rejected',    // 已拒绝
  ARCHIVED: 'archived',    // 已归档
  SCHEDULED: 'scheduled',  // 定时发布
};

// 可见性枚举
export const Visibility = {
  PUBLIC: 'public',        // 公开
  PRIVATE: 'private',      // 私有
  MEMBERS: 'members',      // 仅会员
  PASSWORD: 'password',    // 密码保护
};

// 审核状态枚举
export const ReviewStatus = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

// 媒体类型枚举
export const MediaType = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  DOCUMENT: 'document',
};

// 排序方式枚举
export const SortBy = {
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
  PUBLISHED_AT: 'published_at',
  VIEWS: 'views',
  LIKES: 'likes',
  COMMENTS: 'comments',
  TITLE: 'title',
};

// 排序方向枚举
export const SortOrder = {
  ASC: 'asc',
  DESC: 'desc',
};

/**
 * 创建默认内容对象
 * @param {Object} overrides - 覆盖字段
 * @returns {Object} 默认内容对象
 */
export function createDefaultContent(overrides = {}) {
  return {
    id: null,
    type: ContentType.ARTICLE,
    status: ContentStatus.DRAFT,
    visibility: Visibility.PUBLIC,
    title: '',
    slug: '',
    summary: '',
    body: '',
    cover_url: null,
    tags: [],
    category_id: null,
    author_did: null,
    author_name: '',
    author_avatar: null,
    seo_title: '',
    seo_description: '',
    seo_keywords: '',
    views: 0,
    likes: 0,
    comments: 0,
    favorites: 0,
    shares: 0,
    scheduled_at: null,
    published_at: null,
    created_at: null,
    updated_at: null,
    ...overrides,
  };
}

/**
 * 创建默认分类对象
 * @param {Object} overrides - 覆盖字段
 * @returns {Object}
 */
export function createDefaultCategory(overrides = {}) {
  return {
    id: null,
    name: '',
    slug: '',
    description: '',
    parent_id: null,
    icon: null,
    cover_url: null,
    sort_order: 0,
    content_count: 0,
    is_active: true,
    ...overrides,
  };
}

/**
 * 创建默认标签对象
 * @param {Object} overrides - 覆盖字段
 * @returns {Object}
 */
export function createDefaultTag(overrides = {}) {
  return {
    id: null,
    name: '',
    slug: '',
    description: '',
    color: '#6366f1',
    content_count: 0,
    is_hot: false,
    ...overrides,
  };
}

/**
 * 创建默认媒体对象
 * @param {Object} overrides - 覆盖字段
 * @returns {Object}
 */
export function createDefaultMedia(overrides = {}) {
  return {
    id: null,
    type: MediaType.IMAGE,
    url: '',
    thumbnail_url: null,
    name: '',
    original_name: '',
    mime_type: '',
    size: 0,
    width: null,
    height: null,
    duration: null,
    alt: '',
    caption: '',
    uploader_did: null,
    created_at: null,
    ...overrides,
  };
}

/**
 * 创建默认版本对象
 * @param {Object} overrides - 覆盖字段
 * @returns {Object}
 */
export function createDefaultVersion(overrides = {}) {
  return {
    id: null,
    content_id: null,
    version_number: 1,
    title: '',
    body: '',
    summary: '',
    changes: '',
    editor_did: null,
    editor_name: '',
    created_at: null,
    ...overrides,
  };
}
